export default __webpack_public_path__ + "static/media/terms-and-conditions.0caf3c04.md";